



import React from 'react';
import { Spin } from 'antd';
import moment from 'moment';

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const FeaturedCampaigns = (props) => {
  const { data, loading } = props;
  return (
    <div>
      <section className="trending-causes school-list-sec-3">
        <div className="container">
          { data && data.length ? <h2 className="main-heading text-center bg-title">Featured Campaign</h2> : ''}
            <Spin spinning={loading}>
            {
              data && data.length ?
                <OwlCarousel className="owl-carousel owl-theme campaignTrendingCards" margin={10} dots={true} responsive={{ 0: { items: data.length <= 3 ? data.length : 3 } }} nav={true}>
                  {
                    data.map(({ deadline, address, story, title, progress, amount, cover_photo, end_date, id }, index) => {
                      const daysGone = deadline ? `${Math.abs(moment(deadline).diff(moment(), 'days'))} days left` : 'N/A';
                      const formattedAddress = address ? (address.length >= 35 ? `${address.substring(0, 30)}...` : address) : 'N/A';
                      const formattedStory = story ? (story.length >= 40 ? `${story.substring(0, 40)}...` : story) : 'N/A';
                      const formattedTitle = title ? (title.length >= 25 ? `${title.substring(0, 23)}...` : title) : 'N/A';
                      let cover = '/images/Trending-img-3.png';
                      if (cover_photo) {
                        cover = `${process.env.REACT_APP_BACKEND_BASE_URL}/${cover_photo}`;
                      }
                      return (
                        <div key={index} className="card trending-cause-card trending-cause-card-2">
                          <div style={{ height: '269px' }} className="img">
                            <img src={cover} className="img-fluid" alt="" />
                            <a href={`/donate-money/${id}`} style={{ textAlign: 'center', paddingTop: 14 }} className="donate-btn">DONATE NOW</a>
                          </div>
                          <div className="desc">
                            <div className="text-card"> <span>{formattedAddress}</span> <span>{daysGone}</span> </div>
                            <a style={{ color: 'black' }} href={`/campaign-details/${id}`}>
                              <h1>{formattedTitle}</h1>
                              <p>{formattedStory}</p>
                              <div className="text-card m-0"> <span>Last donation</span> <span>{end_date ? moment(end_date).fromNow() : ''}</span> </div>
                              <div className="progres">
                                <div className="progress-inner">
                                  <div className="progress-bar" role="progressbar" style={{ width: (typeof(progress) === 'string' && progress.includes('%'))  ? `${progress}` : `${progress || 0}%` }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <div className="treanding-cause-bottom">
                                  <h4 className="left-text-s"><span>Raised</span>${amount}</h4>
                                  <h4 className="left-right-s">{(typeof(progress) === 'string' && progress.includes('%')) ? `${progress}` : `${progress || 0}%` }</h4>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      );
                    })
                  }
                </OwlCarousel> : ''
            }
          </Spin>
        </div>
      </section>
    </div>
  );
}

export default FeaturedCampaigns;
